export class ElectronTsdownError extends Error {}
